export const colors = {
  primary: '#0139B7',
  secondary: '#FF4B8C', // Rose vif
  tertiary: '#2cb03b', // Vert émeraude
  accent1: '#ff0000', // Rouge
  accent2: '#9747FF', // Violet
  accent3: '#00B4D8', // Bleu ciel
} as const;